"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardNavigationController = exports.NavigationKey = void 0;
/**
 * Keyboard keys commonly used to navigate UI components. Maps directly to 'key' property of
 * keyboard events.
 */
var NavigationKey;
(function (NavigationKey) {
    NavigationKey[NavigationKey["ArrowDown"] = 0] = "ArrowDown";
    NavigationKey[NavigationKey["ArrowLeft"] = 1] = "ArrowLeft";
    NavigationKey[NavigationKey["ArrowRight"] = 2] = "ArrowRight";
    NavigationKey[NavigationKey["ArrowUp"] = 3] = "ArrowUp";
    NavigationKey[NavigationKey["End"] = 4] = "End";
    NavigationKey[NavigationKey["Enter"] = 5] = "Enter";
    NavigationKey[NavigationKey["Escape"] = 6] = "Escape";
    NavigationKey[NavigationKey["Home"] = 7] = "Home";
    NavigationKey[NavigationKey["PageDown"] = 8] = "PageDown";
    NavigationKey[NavigationKey["PageUp"] = 9] = "PageUp";
})(NavigationKey = exports.NavigationKey || (exports.NavigationKey = {}));
/**
 * Provide a simple mapping from keyboard keys to actions, originating from keyboard events or
 * simulated key press. Removes the need for long switch statements and allows passing/sharing
 * control along the component hierarchy
 */
var KeyboardNavigationController = /** @class */ (function () {
    function KeyboardNavigationController(keyMapping, config) {
        var _this = this;
        /**
         * Handler function to pass to keyboard events (eg onKeyDown). Reads keyMapping and executes the
         * appropriate action, if defined.
         * @param event: the event originating from the DOM
         */
        this.keyEventHandler = function (event) {
            if (_this.config.ignoreModifiers &&
                (event.altKey || event.ctrlKey || event.shiftKey)) {
                return;
            }
            _this.executeKeypress(_this.keyMapping[NavigationKey[event.key]], event);
        };
        /**
         * Simulate a key press, executing the mapped action, if defined.
         */
        this.press = function (key) {
            _this.executeKeypress(_this.keyMapping[NavigationKey[key]]);
        };
        // PRIVATE METHODS -------------------------
        this.executeKeypress = function (action, event) {
            if (action) {
                action();
                if (_this.config.preventDefault && event) {
                    event.preventDefault();
                }
            }
        };
        this.keyMapping = keyMapping;
        this.config = {
            ignoreModifiers: config && config.ignoreModifiers !== undefined
                ? config.ignoreModifiers
                : true,
            preventDefault: config && config.preventDefault !== undefined
                ? config.preventDefault
                : false,
        };
    }
    return KeyboardNavigationController;
}());
exports.KeyboardNavigationController = KeyboardNavigationController;
